import React from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';

const Nosotros = () => {
  
  const teamMembers = [
    {
      name: "Mariajosé Varela",
      role: "Chief Executive Officer",
      description: "Especialista en Early Years, coaching y gestión educativa. Lidera la estrategia global de AV Global, impulsando programas de formación innovadores centrados en el desarrollo humano, la indagación y el aprendizaje significativo en entornos internacionales.",
      image: "/mariajose.jpeg",
      link: "https://linkedin.com/in/mariajos%C3%A9-varela-ampuero-8260a7191/",
      mail: "mariajose.varela@avglobal.edu.pe"
    },
    {
      name: "Alberto Varela",
      role: "Chief Academic Officer",
      description: "Consultor educativo internacional con más de 40 años de experiencia. Experto en debate, MUN y pedagogía crítica. Diseña y supervisa la calidad académica de todos los programas, garantizando excelencia y rigor formativo.",
      image: "/alberto.jpeg",
      link: "https://linkedin.com/in/alberto-varela-anselmi-3399763b5/",
      mail: "alberto.varela@avglobal.edu.pe"
    },
    {
      name: "Patricio Negrón",
      role: "Chief Operations & Strategy Officer",
      description: "Profesional en estrategia, operaciones y transformación digital. Lidera la ejecución, escalamiento y operatividad de los programas educativos, integrando eficiencia, tecnología y visión institucional para asegurar impacto y sostenibilidad.",
      image: "/patricio.jpeg",
      link: "https://linkedin.com/in/luis-patricio-negr%C3%B3n-garc%C3%ADa-2079323a/",
      mail: "patricio.negron@avglobal.edu.pe"
    },
    {
      name: "Mar Gutierrez",
      role: "Chief Communications & Student Engagement Director",
      description: "Comunicadora y head coach de MUN. Experta en engagement estudiantil, formación juvenil y diseño de experiencias educativas. Lidera la comunicación institucional y la conexión activa con estudiantes, colegios y familias.",
      image: "/mar.jpeg",
      link: "https://www.linkedin.com/in/mar-gutierrez-a6804423b/",
      mail: "mar.gutierrez@avglobal.edu.pe"
    }
  ];

  const servicesList = [
    "Programa MUN",
    "Orientación Internacional",
    "Doble Titulación",
    "STEAM & CodEd",
    "Liderazgo Global",
    "Consultoría Educativa"
  ];

  return (
    <>
      <Helmet>
        <title>Nosotros | AV Global</title>
        <meta name="description" content="nose"></meta>
      </Helmet>
      <div className="bg-white font-sans text-gray-800">
        
        {/* 1. HERO SECTION */}
        <section className="relative pt-20 pb-20 px-6 md:px-12 lg:px-16 overflow-hidden">
          <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-sky-100/40 blur-[100px] rounded-full pointer-events-none -z-10 translate-x-1/3 -translate-y-1/3"></div>

          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col lg:flex-row gap-16 items-center">
              <div className="lg:w-1/2">
                <div className="inline-block px-6 py-1.5 border border-gray-400 rounded-full mb-6">
                  <span className="text-gray-600 text-sm font-medium">Nosotros</span>
                </div>
                
                <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#1a3b5c] mb-8 leading-tight tracking-tight">
                  Experiencias formativas de <span className="text-[#5B9BB0]">alto impacto.</span>
                </h1>
                
                <div className="prose prose-lg text-gray-600 leading-relaxed space-y-6">
                  <p>
                    Somos una consultora educativa que diseña e implementa programas innovadores para potenciar el talento joven.
                  </p>
                  <p>
                    Desarrollamos competencias clave para el mundo actual: <strong>oratoria, negociación, pensamiento crítico, investigación, ciudadanía global, bilingüismo y liderazgo estudiantil.</strong>
                  </p>
                </div>
              </div>

              <div className="lg:w-1/2 relative">
                <div className="grid grid-cols-2 gap-4 xl:block xl:relative xl:h-[500px]">
                    <img 
                      src="AV.png" 
                      alt="Conferencia" 
                      className="rounded-[2rem] w-full h-64 object-cover shadow-lg xl:rounded-full xl:w-[350px] xl:h-[350px] xl:absolute xl:top-0 xl:right-0"
                    />
                    <img 
                      src="equipo_lejos.png" 
                      alt="Estudiantes trabajando" 
                      className="rounded-[2rem] w-full h-64 object-cover transform translate-y-8 shadow-lg xl:rounded-full xl:w-[400px] xl:h-[400px] xl:translate-y-0 xl:absolute xl:bottom-0 xl:left-0 xl:z-10 xl:border-[4px] xl:border-white"
                    />
                </div>
                <div className="absolute -bottom-10 -right-10 w-32 h-32 bg-[#254E70] rounded-full -z-10 opacity-20"></div>
              </div>
            </div>
          </div>
        </section>

        <section className="pb-12 border-b border-gray-100 bg-white">
          <div className="max-w-8xl mx-auto px-6">
            <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 text-center">
              {servicesList.map((service, index) => (
                <div key={index} className="flex items-center gap-2 group cursor-default">
                  <div className="w-2 h-2 rounded-full bg-[#5B9BB0] group-hover:scale-125 transition-transform"></div>
                  <span className="text-gray-600 font-medium group-hover:text-[#1a3b5c] transition-colors">{service}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 2. MISSION & VISION */}
        <section id="mision" className="py-16 px-6 md:px-12 lg:px-16 bg-[#F8FAFC]">
          <div className="max-w-7xl mx-auto">
            <div className="grid md:grid-cols-2 gap-8">
              <div className="bg-sky-100 p-10 rounded-[2.5rem] shadow-sm border border-gray-100 flex flex-col justify-between hover:shadow-md transition-shadow duration-300">
                <div>
                  <div className="w-12 h-12 bg-white rounded-2xl flex items-center justify-center mb-6 text-[#254E70]">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="12" cy="12" r="10" />
                      <line x1="2" x2="22" y1="12" y2="12" />
                      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
                    </svg>
                  </div>
                  <h3 className="text-2xl font-bold text-[#1a3b5c] mb-4">Misión</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Diseñar, implementar y escalar programas educativos innovadores que desarrollen habilidades clave y abran puertas a la movilidad académica global, mediante una gestión basada en datos, estándares de excelencia y experiencias reales.
                  </p>
                </div>
              </div>

              <div className="bg-[#1a3b5c] p-10 rounded-[2.5rem] shadow-xl text-white flex flex-col justify-between relative overflow-hidden group">
                <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 group-hover:bg-white/10 transition-colors duration-500"></div>
                <div className="relative z-10">
                  <div className="w-12 h-12 bg-white/10 rounded-2xl flex items-center justify-center mb-6 text-white backdrop-blur-sm">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M2 12h10" />
                      <path d="M9 4l7 8-7 8" />
                      <path d="M22 12h.01" />
                    </svg>
                  </div>
                  <h3 className="text-2xl font-bold mb-4">Visión 2026-2030</h3>
                  <p className="text-gray-200 leading-relaxed">
                    Ser la consultora educativa de referencia en América Latina en formación escolar con enfoque global, logrando que más estudiantes accedan a dobles titulaciones, programas STEAM internacionales y admisiones universitarias en el extranjero.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 4. TEAM SECTION */}
        <section id="equipo" className="py-20 px-6 md:px-12 lg:px-16 bg-white">
          <div className="max-w-7xl mx-auto">
            
            <div className="text-center mb-16 max-w-3xl mx-auto">
              <h2 className="text-4xl font-bold text-[#1a3b5c] mb-6">Nuestro Equipo</h2>
              <p className="text-gray-500 text-lg">
                Contamos con un equipo multidisciplinario con experiencia en formación educativa, gestión académica y consultoría estratégica. Nuestros especialistas garantizan una asesoría integral y rigurosa.
              </p>
            </div>

            <div className="flex flex-col gap-16">
              {teamMembers.map((member, idx) => (
                <div 
                  key={idx} 
                  className={`group flex flex-col ${idx % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} gap-8 md:gap-16 items-center`}
                >
                  
                  {/* Column 1: Image */}
                  <div className="w-full md:w-[40%] flex-shrink-0">
                    <div className="relative overflow-hidden rounded-[1.5rem] aspect-square shadow-sm">
                        <img 
                          src={member.image} 
                          alt={member.name}
                          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                        />
                    </div>
                  </div>

                  {/* Column 2: Content */}
                  <div className="flex flex-col flex-grow justify-center py-2 w-full md:w-1/2">
                    <h3 className="text-3xl font-bold text-[#1a3b5c] mb-2">{member.name}</h3>
                    <div className="text-[#5B9BB0] text-base font-bold uppercase tracking-wide mb-6">{member.role}</div>
                    <p className="text-gray-500 text-lg leading-relaxed mb-8">
                      {member.description}
                    </p>
                    
                    {/* Social/Contact Buttons - ACTUALIZADOS */}
                    <div className="flex gap-4 pt-4 border-t border-gray-200 opacity-60 group-hover:opacity-100 transition-opacity mt-auto md:mt-0">
                      
                      {/* LinkedIn Button */}
                      <a 
                        href={member.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center hover:bg-[#0077b5] hover:text-white transition-all duration-300 cursor-pointer hover:scale-110 active:scale-95"
                        title={`Ver perfil de LinkedIn de ${member.name}`}
                      >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
                          <rect x="2" y="9" width="4" height="12"/>
                          <circle cx="4" cy="4" r="2"/>
                        </svg>
                      </a>

                      {/* Email Button */}
                      <a 
                        href={`mailto:${member.mail}`}
                        className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center hover:bg-[#1a3b5c] hover:text-white transition-all duration-300 cursor-pointer hover:scale-110 active:scale-95"
                        title={`Enviar correo a ${member.name}`}
                      >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                          <polyline points="22,6 12,13 2,6"/>
                        </svg>
                      </a>
                    </div>
                  </div>

                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 3. ENHANCED CTA FOOTER HOOK */}
        <motion.section 
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          className="relative py-24 px-6 md:px-12 mx-4 md:mx-8 mb-8 rounded-[3rem] overflow-hidden text-center text-white"
        >
          <div className="absolute inset-0 bg-[#1a3b5c]"></div>
          {/* Abstract Shapes */}
          <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#5B9BB0]/20 blur-[100px] rounded-full pointer-events-none"></div>
          <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-white/10 blur-[80px] rounded-full pointer-events-none"></div>

          <div className="relative z-10 max-w-3xl mx-auto">
            <h2 className="text-3xl md:text-5xl font-bold mb-6 tracking-tight">
              ¿Prefieres una reunión directa?
            </h2>
            <p className="text-blue-100 text-lg md:text-xl mb-10 leading-relaxed font-light">
              Agenda una videollamada con nuestro equipo de admisiones y recibe asesoría personalizada sin compromiso.
            </p>
            <a href="https://calendly.com/avconsulting-info/30min?month=2026-03" target="_blank" rel="noopener noreferrer">
              <motion.button 
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="bg-white text-[#1a3b5c] hover:bg-blue-50 px-10 py-4 rounded-full font-bold text-lg shadow-xl transition-all"
              >
                Agendar Reunión Virtual
              </motion.button>
            </a>
          </div>
        </motion.section>

      </div>
    </>
  );
};

export default Nosotros;